module.exports = __webpack_public_path__ + "static/media/cert_57.f8f458f7.png";